<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "@/styles/var.scss";
#app {
  // height: 100%;
  box-sizing: border-box;
  background: #f5f5f5;
}
html body{
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// App.vue?23279f1e